import { User } from 'src/constants/types';
import { hasRoleAtLeast, isBhiAdmin } from 'src/helpers/permissions';
import { EntityQRCodeParametersSimpleView } from '../types';

// Only the two fields the check reads, but taken from the profile type, so a rename lands here.
type QRCodePermissionProfile =
  | (Partial<Pick<User, 'type'>> & { role?: Pick<User['role'], 'name'> | null })
  | null
  | undefined;

// A generated code is nothing but its keyword, so there is no record to archive.
export function canArchiveQRCode(
  qrCode: Pick<EntityQRCodeParametersSimpleView, 'generated' | 'authorIsCurrentUser'>,
  profile: QRCodePermissionProfile,
): boolean {
  if (qrCode.generated) return false;
  if (qrCode.authorIsCurrentUser || isBhiAdmin(profile)) return true;
  return hasRoleAtLeast(profile?.role?.name, 'company_admin');
}
